import { Select } from '@mantine/core';
import { FC } from 'react';

import { TIMELINE_INTERVAL_CONFIG, TimelineInterval } from '@/models/Calendar.ts';

import { useCalendarStore } from '@/stores/calendarStore.ts';

const TimelineIntervalSelector: FC = () => {
    const timeline_interval = useCalendarStore((state) => state.timeline_interval);

    const handleTimelineIntervalChange = (value: string | null): void => {
        if (value) {
            const interval = Number.parseInt(value) as TimelineInterval;
            useCalendarStore.setState({ timeline_interval: interval });
        }
    };

    return (
        <Select
            value={timeline_interval.toString()}
            onChange={handleTimelineIntervalChange}
            size="md"
            data={Object.values(TIMELINE_INTERVAL_CONFIG).map((interval) => ({
                value: interval.minutes.toString(),
                label: interval.label.toString(),
            }))}
            className="w-28"
            classNames={{
                dropdown: 'shadow-sm',
                input: 'bg-white text-sm font-bold',
                option: 'text-sm',
            }}
        />
    );
};

export default TimelineIntervalSelector;
